import { render, staticRenderFns } from "./photo-slider-preview-new.vue?vue&type=template&id=b27c32c2&scoped=true&"
import script from "./photo-slider-preview-new.vue?vue&type=script&lang=js&"
export * from "./photo-slider-preview-new.vue?vue&type=script&lang=js&"
import style0 from "./photo-slider-preview-new.vue?vue&type=style&index=0&id=b27c32c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b27c32c2",
  null
  
)

export default component.exports